<template>
    <h1>Sign In</h1>
    <p>
        <input type="text" placeholder="Email" v-model="email"/>
    </p>
    <p>
        <input type="password" placeholder="Password" v-model="password"/>
    </p>
    <p>
        <button @click="signin">Sign In</button>
    </p>
    <p>
        <button @click="signInWithGoogle">Sign In With Google</button>
    </p>
</template>
<script setup>
import { ref } from "vue";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useRouter } from "vue-router";

const email = ref("");
const password = ref("");
const router = useRouter();

const signin = () => {
    signInWithEmailAndPassword(getAuth(), email.value, password.value)
    .then(()=>{
        console.log("Signed In!")
        router.push("/livesession")
    })
    .catch(()=>{
        console.log("Fail")
    })
}

</script>